export default __webpack_public_path__ + "static/media/masha.c448d02e.webp";